export default __webpack_public_path__ + "static/tp-link-b8beb95371f603b4f6aead9ff216b1ea.jpg";